import type {
  SimilarSurveysQualificationDto,
  SimilarSurveysQuotaDto,
  SimilarSurveysRangeSetDto,
  SimilarSurveysRequestDto,
} from '../../api/similar-surveys/dtos/similar-surveys.dto';

const KEY_VERSION = 'v1';

export const similarSurveysTargetingKey = (
  payload: SimilarSurveysRequestDto,
): string =>
  [
    KEY_VERSION,
    `loc=${payload.survey_localization}`,
    `completes=${payload.completes_required}`,
    `ir=${payload.expected_ir}`,
    `loi=${payload.expected_loi}`,
    `ft=${payload.field_time}`,
    `quals=${normalizeStringOrder(payload.qualifications.map(criterionKey)).join(';')}`,
    `quotas=${normalizeStringOrder(payload.quotas.map(quotaKey)).join('&')}`,
  ].join('|');

function criterionKey(criterion: SimilarSurveysQualificationDto): string {
  const code = `q${criterion.qualification_code}`;
  return criterion.range_sets
    ? `${code}:r=${normalizeStringOrder(criterion.range_sets.map(rangeKey)).join(',')}`
    : `${code}:c=${normalizeStringOrder([...criterion.condition_codes]).join(',')}`;
}

function rangeKey(range: SimilarSurveysRangeSetDto): string {
  return `${range.from}-${range.to}-${range.units}`;
}

function quotaKey(quota: SimilarSurveysQuotaDto): string {
  const criteria = normalizeStringOrder(quota.criteria.map(criterionKey)).join(
    ';',
  );
  return `${quota.quota_category}#${quota.required_count}#${criteria}`;
}

function normalizeStringOrder(values: string[]): string[] {
  return [...values].sort(compareStrings);
}

function compareStrings(left: string, right: string): number {
  if (left === right) {
    return 0;
  }
  return left < right ? -1 : 1;
}
